<template>
<div class="chapter">
<div class="inner_page">
<div class="cover">
<img alt="" src="images/9781250145666.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?28cd7668